import CreateMacro from './CreateMacro'
import { CreateMacroDataProvider } from './CreateMacroDataProvider'

export default (props) ->
  <CreateMacroDataProvider>
    <CreateMacro { props... } />
  </CreateMacroDataProvider>

